import React from "react";

const YEARS = [1, 2, 3];
const ROMAN = { 1: "I", 2: "II", 3: "III" };

export function YearLevelsPicker({ value = [], onChange, testId = "session-years" }) {
  const toggle = (y) => onChange(value.includes(y) ? value.filter((v) => v !== y) : [...value, y].sort());
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      {YEARS.map((y) => {
        const on = value.includes(y);
        return (
          <button
            key={y}
            type="button"
            onClick={() => toggle(y)}
            data-testid={`${testId}-${y}`}
            aria-pressed={on}
            className={`h-8 px-3 rounded-full border text-xs font-medium transition-colors duration-150 ${on ? "bg-[#1C352D] text-white border-[#1C352D]" : "bg-white text-stone-600 border-stone-300 hover:border-[#1C352D]"}`}
          >
            {ROMAN[y]} anno
          </button>
        );
      })}
      {value.length === 0 && <span className="text-[11px] text-stone-400 ml-1">Tutti gli anni</span>}
    </div>
  );
}
